import { render, staticRenderFns } from "./QuoteBanner.vue?vue&type=template&id=93b5493e&scoped=true"
import script from "./QuoteBanner.vue?vue&type=script&lang=js"
export * from "./QuoteBanner.vue?vue&type=script&lang=js"
import style0 from "./QuoteBanner.vue?vue&type=style&index=0&id=93b5493e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b5493e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93b5493e')) {
      api.createRecord('93b5493e', component.options)
    } else {
      api.reload('93b5493e', component.options)
    }
    module.hot.accept("./QuoteBanner.vue?vue&type=template&id=93b5493e&scoped=true", function () {
      api.rerender('93b5493e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuoteBanner/QuoteBanner.vue"
export default component.exports